/**
 * @module EnvStore
 * @description This module is written in a legacy style. Do not copy it. Instead, use repositories to manage state and persistence. Refer to ui/README.md for more.
 */

import { asyncReadable } from "@square/svelte-store";

export interface Env {
  API_URI: string | undefined;
  PLATFORM_URI: string | undefined;
  BASE_URI: string | undefined;
  CONFIGURABLE_API_URI: boolean | undefined;
  SENTRY_DSN: string | undefined;
}

const DEFAULT: Env = {
  API_URI: undefined,
  PLATFORM_URI: undefined,
  BASE_URI: undefined,
  CONFIGURABLE_API_URI: undefined,
  SENTRY_DSN: undefined,
};

class MisconfigurationError extends Error {}

export const envStore = asyncReadable<Env>(DEFAULT, async () => {
  let env = DEFAULT;
  try {
    const resp = await fetch("/~/env");
    const json = await resp.json();
    env = {
      API_URI: valueOrUndefined(json["API_URI"]),
      PLATFORM_URI: valueOrUndefined(json["PLATFORM_URI"]),
      BASE_URI: valueOrUndefined(json["BASE_URI"]),
      CONFIGURABLE_API_URI: json["CONFIGURABLE_API_URI"],
      SENTRY_DSN: valueOrUndefined(json["SENTRY_DSN"]),
    };
  } catch (_e) {
    return env;
  }

  assertBaseURI(env["BASE_URI"]);
  assertAPIURI(env["API_URI"]);

  return env;
});

function assertBaseURI(base?: string) {
  if (base == null) return;

  const parsed = new URL(base);
  if (parsed.origin !== window.location.origin) {
    throw new MisconfigurationError(
      `BASE_URI origin does not match current page. Expected ${window.location.origin} but got ${parsed.origin}`,
    );
  }
}
function assertAPIURI(uri?: string) {
  if (uri == null) return;
  new URL(uri);
}

function valueOrUndefined(v?: string) {
  return v === "" ? undefined : v;
}
